<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.reports'), $t('reports.omsProductSaleRanking')]"
      >
      </breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
        label-width="110px"
      >
        <el-form-item
          :label="$t('settlement.dateType')"
          :prop="'_dateType'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('settlement.dateType')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-radio-group size="small" v-model="searchForm._dateType">
            <el-radio label="confirmAt">{{
              $t("menu.bargains") + $t("order.confirmAt")
            }}</el-radio>
            <el-radio label="createAt">{{
              $t("menu.bargains") + $t("text.createAt")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <br />
        <el-form-item
          :label="$t('settlement.dateRange')"
          :prop="'_dataRange'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('settlement.dateRange')]),
              trigger: 'blur',
            },
          ]"
        >
          <date-range
            v-model="searchForm"
            type="datetime"
            field="_dataRange"
            :start-placeholder="$t('text.startAt')"
            :end-placeholder="$t('text.endAt')"
          />
        </el-form-item>
        <br />
        <el-form-item
          :label="$t('salesTarget.userName')"
          v-if="users.length != 0"
        >
          <el-checkbox-group v-model="searchForm.ownerIds">
            <el-checkbox v-for="user of users" :key="user.id" :label="user.id">
              <span v-if="user.voidAt != null" class="deleted">
                {{ user.name }}
              </span>
              <span v-else>{{ user.name }}</span>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <br v-if="users.length != 0" />
        <el-form-item :label="$t('menu.shops')">
          <el-checkbox-group v-model="searchForm.shopIds">
            <el-checkbox
              v-for="(shop, index) of shops"
              :key="index"
              :label="shop.id"
              >{{ shop.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <br v-if="categories.length != 0" />
        <el-form-item :label="$t('menu.categories')">
          <el-checkbox-group v-model="searchForm.categoryIds">
            <el-checkbox
              v-for="(category, index) of categories"
              :key="index"
              :label="category.id"
              >{{ category.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <br />
        <el-form-item :label="'统计方式'">
          <el-radio-group v-model="searchForm.groupByType">
            <el-radio label="product"> 款号 </el-radio>
            <el-radio label="productc"> 款号、颜色 </el-radio>
            <el-radio label="products"> 款号、规格 </el-radio>
            <el-radio label="productcs"> 款号、颜色、规格 </el-radio>
          </el-radio-group>
        </el-form-item>
        <br />
        <el-form-item :label="'排名方式'">
          <el-radio-group v-model="searchForm.rankBy">
            <el-radio label="salesAmount"> 按成交额 </el-radio>
            <el-radio label="productQty"> 按订单量 </el-radio>
          </el-radio-group>
        </el-form-item>
        <br />
        <el-form-item :label="$t('product.productNo')">
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          ></el-input>
        </el-form-item>
        <br />
        <el-form-item :label="' '">
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            >{{ $t("text.search") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="default" size="mini" @click="download">
              {{ $t("action.download") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column type="seq" :title="'名次'" width="80" />
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
          v-if="
            ['product', 'productc', 'products', 'productcs'].includes(
              searchForm.groupByType
            )
          "
        />
        <vxe-table-column
          field="categoryName"
          :title="$t('menu.categories')"
          min-width="100"
          v-if="
            ['product', 'productc', 'products', 'productcs'].includes(
              searchForm.groupByType
            )
          "
        />
        <vxe-table-column
          field="color"
          :title="$t('product.color')"
          min-width="100"
          v-if="['productc', 'productcs'].includes(searchForm.groupByType)"
        />
        <vxe-table-column
          field="size"
          :title="$t('product.size')"
          min-width="100"
          v-if="['products', 'productcs'].includes(searchForm.groupByType)"
        />
        <vxe-table-column
          field="productQty"
          :title="$t('report.orderQty')"
          min-width="80"
        />
        <vxe-table-column
          field="salesAmount"
          :title="$t('bargain.amount')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.salesAmount | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="returnQty"
          :title="$t('report.returnQty')"
          min-width="80"
        />
        <vxe-table-column
          field="returnAmount"
          :title="$t('report.returnAmount')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.returnAmount | currency }}
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import DateRange from "@/components/DateRange";
import User from "@/api/user";
import Shop from "@/api/shop";
import Category from "@/api/category";
import Order from "@/api/order";

export default {
  mixins: [page, table.pager, table.search],
  components: { DateRange },
  data() {
    return {
      searchForm: {
        confirmAtStartAt: null,
        confirmAtEndAt: null,
        createAtStartAt: null,
        createAtEndAt: null,
        shopIds: [],
        ownerIds: [],
        categoryIds: [],
        groupByType: "product",
        rankBy: "salesAmount",
        _dateType: "confirmAt",
        _dataRange: null,
        _dataRangeStartAt: null,
        _dataRangeEndAt: null,
        productNo: null,
      },
      users: [],
      shops: [],
      categories: [],
      //
      records: [],
      totals: [],
      loading: false,
    };
  },

  created() {
    const self = this;
    axios
      .all([
        Shop.findByTenantId(),
        User.findByTenantId(),
        Category.findByTenantId(),
      ])
      .then(
        axios.spread(function (shops, users, categories) {
          if (shops.status == 200) {
            self.shops = shops.data;
          } else {
            self.sysError();
          }
          if (users.status == 200) {
            self.users = users.data.filter(
              (u) =>
                (u.voidAt == null && u.authorize == true) || u.voidAt != null
            );
          } else {
            self.sysError();
          }
          if (categories.status == 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    //
    download() {
      const self = this;
      if (self.searchForm._dataRangeStartAt == null) {
        self.$message({
          message: "请选择日期范围",
          type: "warning",
        });
        return;
      }
      if (self.records.length == 0) {
        this.$message({
          message: self.$t("text.noData"),
          type: "warning",
        });
        return;
      }

      Order.productSaleRankingReportExportExcel(self.combineParams()).then(
        function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.downloadPrompt"),
              type: "success",
            });
            self.checkedRows = [];
            self.$eventHub.$emit("emitDownLoad");
          } else {
            self.$message.error(self.$t("prompt.downloadErr"));
          }
        }
      );
    },
    //
    loadData() {
      const self = this;
      if (self.searchForm._dataRangeStartAt == null) {
        self.$message({
          message: "请选择日期范围",
          type: "warning",
        });
        return;
      }

      self.loading = true;
      Order.productSaleRankingReport(self.combineParams()).then(function (res) {
        self.loading = false;
        if (res.status === 200) {
          self.records = res.data.records;
          self.pager.total = res.data.total;
        } else {
          self.sysError();
        }
      });
    },
    //
    changePager(params) {
      this.pager.currentPage = params.currentPage;
      this.pager.pageSize = params.pageSize;
      this.loadData();
    },
    combineParams() {
      const self = this;
      self.searchForm.confirmAtStartAt = null;
      self.searchForm.confirmAtEndAt = null;
      self.searchForm.createAtStartAt = null;
      self.searchForm.createAtEndAt = null;
      if (self.searchForm._dateType == "confirmAt") {
        self.searchForm.confirmAtStartAt = self.searchForm._dataRangeStartAt;
        self.searchForm.confirmAtEndAt = self.searchForm._dataRangeEndAt;
      }
      if (self.searchForm._dateType == "createAt") {
        self.searchForm.createAtStartAt = self.searchForm._dataRangeStartAt;
        self.searchForm.createAtEndAt = self.searchForm._dataRangeEndAt;
      }

      let params = {};
      if (this.pager) {
        params.currentPage = this.pager.currentPage;
        params.pageSize = this.pager.pageSize;
      }
      if (this.searchForm) {
        for (let key in this.searchForm) {
          if (
            this.searchForm[key] &&
            JSON.stringify(this.searchForm[key]) != "[]"
          ) {
            params[key] = this.searchForm[key];
          }
        }
      }
      return params;
    },
  },
};
</script>
<style >
.el-form-item__content {
  height: auto !important;
}
</style>